// extracted by mini-css-extract-plugin
export var modal = "_40-0";